import React from 'react';
import { Field } from 'formik';
import Link from '@nib-components/link';
import { FullStoryMask } from '@nib-components/form-control';
import NestedFormFields from '../nested-form-fields';
import { AusMailingAddressRadio, States, AusPostcode, Suburb, StreetAddress, AusAddressLookup } from '../..';
import { getGroupEventHandlerProps } from '../../util/propTypes';
class AusMailingAddressGroup extends React.Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    this.state = {
      showManualEntryFields: false
    };
    this.showHideManualEntryFields = function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      _this.setState({
        showManualEntryFields: !_this.state.showManualEntryFields
      });
      if (value === 'close') {
        _this.clearFields();
      }
    };
    this.renderManualAddress = () => {
      const {
        id = 'ausMailingAddressGroup',
        name = 'ausMailingAddressGroup',
        groupOnBlurHandlers = {},
        groupOnChangeHandlers = {},
        optional = false
      } = this.props;
      const eventHandlers = {
        groupOnBlurHandlers,
        groupOnChangeHandlers
      };
      return React.createElement(React.Fragment, null, React.createElement(Link, {
        id: `${name}--undoButton`,
        component: "button",
        type: "button",
        onClick: () => this.showHideManualEntryFields('close')
      }, "Undo manual address entry."), React.createElement(Field, {
        name: `${name}--streetAddress`,
        id: `${id}--streetAddress`,
        optional: optional,
        component: StreetAddress,
        ...getGroupEventHandlerProps({
          ...eventHandlers,
          id: `${name}--streetAddress`
        })
      }), React.createElement(Field, {
        name: `${name}--suburb`,
        id: `${id}--suburb`,
        optional: optional,
        component: Suburb,
        ...getGroupEventHandlerProps({
          ...eventHandlers,
          id: `${name}--suburb`
        })
      }), React.createElement(Field, {
        name: `${name}--states`,
        id: `${id}--states`,
        optional: optional,
        component: States,
        ...getGroupEventHandlerProps({
          ...eventHandlers,
          id: `${name}--states`
        })
      }), React.createElement(Field, {
        name: `${name}--postcode`,
        id: `${id}--postcode`,
        optional: optional,
        component: AusPostcode,
        ...getGroupEventHandlerProps({
          ...eventHandlers,
          id: `${name}--postcode`
        })
      }));
    };
    this.renderAddressForms = () => {
      const {
        name = 'ausMailingAddressGroup',
        label,
        stateToFilterOn = '',
        kleberApiKey,
        excludeAddressRadio = false,
        groupOnBlurHandlers = {},
        groupOnChangeHandlers = {},
        optional = false,
        required
      } = this.props;
      const {
        showManualEntryFields
      } = this.state;
      const eventHandlers = {
        groupOnBlurHandlers,
        groupOnChangeHandlers
      };
      return React.createElement(React.Fragment, null, !showManualEntryFields && React.createElement(Field, {
        required: required,
        name: `${name}--ausAddressLookup`,
        id: `${name}--ausAddressLookup`,
        component: AusAddressLookup,
        stateToFilterOn: stateToFilterOn,
        kleberApiKey: kleberApiKey,
        showHideManualEntryFields: this.showHideManualEntryFields,
        optional: optional,
        label: label,
        ...getGroupEventHandlerProps({
          ...eventHandlers,
          id: `${name}--ausAddressLookup`
        })
      }), excludeAddressRadio ? React.createElement(NestedFormFields, {
        expanded: showManualEntryFields,
        id: `${name}--nestedFormFields`,
        subHeading: "Enter your address"
      }, showManualEntryFields && this.renderManualAddress()) : showManualEntryFields && this.renderManualAddress());
    };
  }
  clearFields() {
    const {
      setFieldValue,
      name = 'ausMailingAddressGroup'
    } = this.props;
    if (setFieldValue) {
      setFieldValue(`${name}--ausAddressLookup`, '');
      setFieldValue(`${name}--streetAddress`, '');
      setFieldValue(`${name}--suburb`, '');
      setFieldValue(`${name}--states`, '');
      setFieldValue(`${name}--postcode`, '');
    }
  }
  render() {
    const {
      id = 'ausMailingAddressGroup',
      name = 'ausMailingAddressGroup',
      radioLabel,
      values,
      excludeAddressRadio = false,
      groupOnBlurHandlers = {},
      groupOnChangeHandlers = {},
      optional = false
    } = this.props;
    const showSubfields = id && values && values[id] === 'yes' || false;
    const eventHandlers = {
      groupOnBlurHandlers,
      groupOnChangeHandlers
    };
    return React.createElement("div", null, !excludeAddressRadio && React.createElement(Field, {
      name: name,
      fullstory: "unmask",
      id: id,
      label: radioLabel,
      component: AusMailingAddressRadio,
      ...getGroupEventHandlerProps({
        ...eventHandlers,
        id
      }),
      optional: optional
    }), excludeAddressRadio ? React.createElement(FullStoryMask, null, this.renderAddressForms()) : React.createElement(NestedFormFields, {
      expanded: showSubfields,
      id: `${name}--nestedFormFields`,
      subHeading: "Enter your address"
    }, React.createElement(FullStoryMask, null, this.renderAddressForms())));
  }
}
AusMailingAddressGroup.defaultProps = {
  stateToFilterOn: '',
  id: 'ausMailingAddressGroup',
  name: 'ausMailingAddressGroup',
  excludeAddressRadio: false,
  groupOnBlurHandlers: {},
  groupOnChangeHandlers: {},
  optional: false
};
export default AusMailingAddressGroup;